// @@flow
import { PURGE_DATA } from './timer';

const UPDATE_PAIRS = '@@checkout/ui_to_be_cached/update_pairs';

const initialState = {
  merchantType: undefined,

  asAboveChecked: false,
  csForPaidyAsAbove: false,
  receptionAsAbove: false,
  devAsAbove: false,
};

const uiToBeCached = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAIRS: {
      return {
        ...state,
        ...action.pairs,
      };
    }
    case PURGE_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};

export const updatePairs = pairs => ({
  type: UPDATE_PAIRS,
  pairs,
});

export default uiToBeCached;
